import { CommerceToolsApi } from '@grandvisionhq/commercetools';
import { formatPrice, mapProductTypeToProductCategory, mapProductStockToProductStatus } from '@grandvisionhq/svc-tealium/utils';
import { isDefined } from '@grandvisionhq/utils';
import { getActiveVariant, getProductModelName, getAvailableQuantity } from '../../../helpers.js';

/**
 * Please be aware that this mapper is isolated from the other mappers created to support Tealium events.
 * When changing this mapper make sure to check the other mappers to make sure information being sent to
 * Tealium is consistent.
 */ const mapProductToTealiumImpressionProperties = (configFlow, product, activeSku, productType, productPrice, lensUpc, locale)=>{
    if (!product || !activeSku || !productType || !locale || !configFlow) {
        return undefined;
    }
    const activeVariant = getActiveVariant(product, activeSku);
    let originalPrice = '';
    let discountedPrice = '';
    if (productPrice) {
        originalPrice = formatPrice(productPrice.originalPrice, true);
        discountedPrice = productPrice.discountedPrice ? formatPrice(productPrice.discountedPrice, true) : originalPrice;
    }
    const productProperties = {
        Category: mapProductTypeToProductCategory(productType),
        ModelName: getProductModelName(activeVariant, locale, productType),
        Price: discountedPrice,
        PriceFull: originalPrice,
        LensType: 'RX',
        Units: '1',
        LensUPC: lensUpc || '',
        Brand: activeVariant.brand || ''
    };
    const isPublished = Boolean(product.published && activeVariant.isPublished);
    if (!CommerceToolsApi.isLenses(productType) && isDefined(activeVariant.availability)) {
        const availableQuantity = getAvailableQuantity(activeVariant.availability);
        productProperties.Status = mapProductStockToProductStatus(availableQuantity, isPublished);
    }
    var _stepName;
    const payload = {
        id: 'Impression',
        Page_Section1: CommerceToolsApi.isSunglasses(productType) ? 'SunLensPanel' : 'LensPanel',
        Page_Section2: (_stepName = configFlow.stepName) !== null && _stepName !== void 0 ? _stepName : '',
        Rx_Release: configFlow.version,
        Products: {
            [activeSku]: productProperties
        }
    };
    return payload;
};

export { mapProductToTealiumImpressionProperties };
//# sourceMappingURL=map-product-to-tealium-impression-properties.js.map
